// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsAppFloat_whatsappButton__8BGYj"};